'use strict';



import { toJS, observe } from "mobx";
import setupElm from './setup-elm';
import { hasSize } from '../lib/is-mobile';
import { setupClickDropdown } from '../lib/dropdown';
import fixElementTop from './element-top';


function fixMiniCartMobileTop (cart) {
    if ( hasSize('md') ) {
        fixElementTop(cart);
    } else {
        cart.style.top = '100%';
    }
}

function formatItemForElm (item) {
    return {
        ...item,
        quantity: item.cartQuantity,
        type_: item.type,
        price: item.total,
    };
}

function setupElmElement () {
    setupElm({
        selector: 'section.mini-cart',
        moduleName: 'MiniCart',
        formatFlags: dataset => {
            if ( dataset.items ) {
                const items = JSON.parse(dataset.items);

                return items.map(formatItemForElm);
            }
            return [];
        },
        construct (module) {

            const miniCart = document.querySelector('.minicart.submenu');
            const miniCartToggle = miniCart.querySelector('.toggle');
            const closeMiniCartBtn = miniCart.querySelector('.close-minicart-btn');
            const miniCartCount = miniCart.querySelector('.cart-count');

            closeMiniCartBtn.addEventListener('click', evt => {
                evt.stopPropagation();
                miniCart.classList.remove('open');
                miniCartToggle.classList.remove('open');
            });

            const gotoCartUrl = miniCart.querySelector('.gotoCart').href;

            miniCart.addEventListener('click', evt => {
                if ( hasSize('md') ) {
                    evt.preventDefault();
                    evt.stopImmediatePropagation();

                    window.location.href = gotoCartUrl;
                }
            });

            observe(window.store.product, 'cart', () => {
                const cart = toJS(window.store.product.cart);

                if ( !document.querySelector('body.cart') && !document.querySelector('body.checkout') ) {
                    const mousedownEvent = new Event('mousedown', {
                        bubbles: true,
                    });

                    if ( !miniCart.classList.contains('open') ) {
                        miniCart.dispatchEvent(mousedownEvent);
                    }

                    fixMiniCartMobileTop(miniCartToggle);

                    if ( miniCartCount ) {
                        miniCartCount.classList.add('effect');
                        window.setTimeout(() =>
                            miniCartCount.classList.remove('effect')
                        , 1000);
                    }
                }

                module
                    .ports
                    .changedCart
                    .send(cart.products.map(formatItemForElm) || []);
            });
        },

        ports: {
            deleteItem (item) {
                window.store.product.deleteCartItem({
                    ...item,
                    cartQuantity: item.quantity,
                });
            },
        },
    });
}


export default function setupMiniCart () {
    setupElmElement();

    document.querySelectorAll('.minicart.submenu')
        .forEach(setupClickDropdown);

    const checkoutBtn = document.querySelector('.minicart .go-to-cart');
    if ( checkoutBtn ) {
        checkoutBtn.href = window.sLanguage !== 'nl'
                            ? `/${window.sLanguage}/winkelwagen`
                            : '/winkelwagen';
    }
}
